<code [innerHTML]="highlightedJson()"></code>
